import { IStreamData } from "@formant/core/model/IStreamData";
import { ITags } from "@formant/core/model/ITags";
import { StreamType } from "@formant/core/model/StreamType";

import { ITagSplitStreamData } from "./ITagSplitStreamData";

export function pointsByTagValue<T extends StreamType>(
    datas: IStreamData<T>[],
    tagKey?: string,
): ITagSplitStreamData<T>[] {
    return Object.values(
        datas.reduce<{
            [key: string]: ITagSplitStreamData<T>;
        }>((acc, data) => {
            const { deviceId, name, type, tags, points } = data;
            const splitTags: ITags =
                tagKey === undefined
                    ? tags
                    : tagKey === ""
                      ? {}
                      : { [tagKey]: tags[tagKey] || "" };
            const key = JSON.stringify({ deviceId, name, type, splitTags });
            acc[key] = acc[key] || {
                deviceId,
                name,
                type,
                tags: splitTags,
                points: [],
            };
            const last = acc[key];
            last.points = last.points.concat(
                points.map(([timestamp, value]) => ({
                    time: new Date(timestamp),
                    value,
                    tags,
                })),
            );
            return acc;
        }, {}),
    ).map(data => ({
        ...data,
        points: data.points.sort((a, b) => a.time.getTime() - b.time.getTime()),
    }));
}
